import Trip from 'model/ITrip';

import { CombinedActionTypes } from '../../actionsFactory';

export interface State {
  [id: string]: {
    data?: Trip;
    isLoading: boolean;
    error?: any;
  };
}

export const initState: State = {};

const initEntry = {
  data: null,
  isLoading: false,
  error: null,
};

export default (state: State, action: CombinedActionTypes): State => {
  switch (action.type) {
    case 'ARCHIVED_BOOKINGS:FETCHING_SUCCESS':
    case 'UPCOMING_BOOKINGS:FETCHING_SUCCESS':
      return action.payload.result.data.reduce<State>(
        (accumulator, booking) => {
          accumulator[booking.id] = {
            data: booking,
            isLoading: false,
            error: null,
          };
          return accumulator;
        },
        state,
      );
    case 'BOOKING:FETCHING':
      return {
        ...state,
        [action.payload.id]: {
          ...initEntry,
          ...state[action.payload.id],
          isLoading: true,
        },
      };
    case 'BOOKING:FETCHING_SUCCESS':
      return {
        ...state,
        [action.payload.result.data.id]: {
          ...initEntry,
          data: action.payload.result.data,
        },
      };
    case 'BOOKING:FETCHING_ERROR':
      return {
        ...state,
        [action.payload.id]: {
          ...initEntry,
          ...state[action.payload.id],
          error: action.payload.error,
        },
      };
    case 'BOOKING:TRANSFER':
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          data: {
            ...state[action.payload.id].data,
            host_id: action.payload.newHostId,
          },
        },
      };
    case 'CONTACTS:FETCHING_BOOKINGS_SUCCESS':
      type Booking = Trip & { _type: 'booking' };
      return action.payload.result.relations
        .filter<Booking>((item): item is Booking => item._type === 'booking')
        .reduce<State>((accumulator, booking) => {
          accumulator[booking.id] = {
            data: booking,
            isLoading: false,
            error: null,
          };
          return accumulator;
        }, state);
    default:
      return state;
  }
};
